export default __webpack_public_path__ + "static/media/background.451d598f.jpeg";